import React from "react";
import "./ImageCollage.css"; // Import the CSS for styling
import COUNTRY_CODE_MAP from './countryCodes';
 const API_KEY = process.env.PIXABAY_API_KEY || '50554140-ee11d09e043c1286e5d1083b6';

// Add your Google Places API key here


// Helper: Get flag image URL
function getFlagUrl(country,place_id = null) {
  const code = COUNTRY_CODE_MAP[country] || country.slice(0, 2).toLowerCase();
  return `https://flagcdn.com/w320/${code}.png`;
}




/*


async function fetchLocationsURL (locationName,placeId = null) {
  const shortName = getShortLocationName(locationName);
     let  queries = [
      `"${shortName}"`, // exact phrase match
      shortName,        // fallback: plain name

    ];
    for (const q of queries) {
    const url = `https://pixabay.com/api/?key=${API_KEY}&q=${encodeURIComponent(q)}&image_type=photo&orientation=horizontal&per_page=5`;
    try {
      const res = await fetch(url);
      const data = await res.json();
      if (data.hits && data.hits.length > 0) {
        // Try to find an image where tags or user-provided description includes the location name
        const lowerName = locationName.toLowerCase();
        const exact = data.hits.find(
          hit =>
            (hit.tags && hit.tags.toLowerCase().includes(lowerName)) ||
            (hit.pageURL && hit.pageURL.toLowerCase().includes(lowerName))
        );
        if (exact)  { console.log("found location" , shortName); return exact.webformatURL; }
        // Otherwise, return the first result
        console.log("Not Found image for location:", shortName);
        // search in wikimedia 
        // call API to retrieve photo reference using fetch for specific placeId
        
          const photoUrl = await fetchGooglePlacePhoto( shortName);  
          return photoUrl || null;
        
  
      }
        
    } catch (e) {
      // ignore
    }
  }
  return null;
}

*/

// Helper: Fetch Pixabay image URL for a country (returns a Promise)
async function fetchPixabayImageUrl(locationName) {
  const shortName = getShortLocationName(locationName);
 
 
 const   queries = [
      
      `"${shortName} landmark"`,
// tourism, nature, cityscape, famous place, culture
      `"${shortName} tourism"`,
      `"${shortName} nature"`,
      `"${shortName} cityscape"`,
      `"${shortName} famous place"`,
      `"${shortName} culture"`,
      shortName
    ];

  for (const q of queries) {
    const url = `https://pixabay.com/api/?key=${API_KEY}&q=${encodeURIComponent(q)}&image_type=photo&orientation=horizontal&per_page=5`;
    try {
      const res = await fetch(url);
      const data = await res.json();
      if (data.hits && data.hits.length > 0) {
        // Try to find an image where tags or user-provided description includes the location name
        const lowerName = locationName.toLowerCase();
        const exact = data.hits.find(
          hit =>
            (hit.tags && hit.tags.toLowerCase().includes(lowerName)) ||
            (hit.pageURL && hit.pageURL.toLowerCase().includes(lowerName))
        );
        if (exact)  return exact.webformatURL;
        // Otherwise, return the first result
        return data.hits[0].webformatURL;
      }
    } catch (e) {
      // ignore
    }
  }
  return null;
}


function ImageCollage({ countries}) {
  const [imageUrls, setImageUrls] = React.useState([]);

  React.useEffect(() => {
    let isMounted = true;
    async function loadImages() {
      if (!countries || countries.length === 0) return;
      const shown = countries.slice(0, 3); // always up to 3
      const urls = await Promise.all(
        shown.map(async (country) => {  
                const img = await fetchPixabayImageUrl(country);
                return img || getFlagUrl(country);
        })
      );
      if (isMounted) setImageUrls(urls);
    }
    loadImages();
    return () => { isMounted = false; };
  }, [countries]);

  if (!countries || countries.length === 0) return null;
  const shown = countries.slice(0, 3);
  if (imageUrls.length === 0) {
    // Loading state: show flags as placeholders
    return (
      <div className="trip-country-collage">
        {shown.map((country, idx) => (
          <img
            key={country}
            src={getFlagUrl(country)}
            alt={country}
            className={`trip-country-image collage-multi collage-multi-${idx} collage-multi-count-${shown.length}`}
            style={{ width: `${100 / shown.length}%` }}
          />
        ))}
      </div>
    );
  }
  if (shown.length === 1) {
    return (
      <img
        src={imageUrls[0]}
        alt={shown[0]}
        className="trip-country-image collage-single"
      />
    );
  }
  // Multiple countries: collage
  return (
    <div className="trip-country-collage">
      {shown.map((country, idx) => (
        <img
          key={country}
          src={imageUrls[idx]}
          alt={country}
          className={`trip-country-image collage-multi collage-multi-${idx} collage-multi-count-${shown.length}`}
          style={{ width: `${100 / shown.length}%` }}
        />
      ))}
    </div>
  );
}

// Utility: Shorten location name if it includes "&" or "and"
function getShortLocationName(locationName) {
  if (!locationName) return locationName;
  // Remove everything starting from '(', '-', or '/' and split on " & " or " and "
  let cleaned = locationName.split('(')[0].split('-')[0].split('/')[0];
  const match = cleaned.split(/\s*(?:&|and)\s+/i);
  return match[0].trim();
}

export {ImageCollage};